import { render, staticRenderFns } from "./AboutPageMainDirections.vue?vue&type=template&id=5dfcd392&scoped=true"
import script from "./AboutPageMainDirections.vue?vue&type=script&lang=ts"
export * from "./AboutPageMainDirections.vue?vue&type=script&lang=ts"
import style0 from "./AboutPageMainDirections.vue?vue&type=style&index=0&id=5dfcd392&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dfcd392",
  null
  
)

export default component.exports